<div id="content" class="w-full bg-gray-100 ">
<router-outlet></router-outlet>
</div>